import { render } from "./PhysicianJobs.vue?vue&type=template&id=46532ea0&scoped=true"
import script from "./PhysicianJobs.vue?vue&type=script&lang=js"
export * from "./PhysicianJobs.vue?vue&type=script&lang=js"

import "./PhysicianJobs.vue?vue&type=style&index=0&id=46532ea0&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46532ea0"]])

export default __exports__